import React, { useEffect, useState } from 'react';
import { Image, Modal } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import AuthButton from 'components/base/AuthButton';
import PromptButton, { BUTTON_TYPES } from 'components/base/prompt/BaseButtons';
import { CustomTitleWithDropDown } from 'components/customer/CustomTitleWithDropDown';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import CustomerFilterableDropdown from 'components/transactions/CustomerFilterableDropdown';
import { COUPON_TYPES } from 'config/CustomEnums';
import { PermissionCodes } from 'config/PermissionCodes';
import { ToastType, defaultDelayTime } from 'models/NavBarModel';

import { createAction } from 'utils';

import CloseIcon from 'assets/images/prompt_close_icon.svg';

import './CouponSelectOwnerModal.scss';

const mapPropsToState = (state) => ({
  customer: state.customerList.customer,
});

const CouponSelectOwnerModal = ({ customer, coupon, show, setShow }) => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const couldSelectStore = coupon?.couldSelectStore;

  const [selectCustomer, setSelectCustomer] = useState(null);
  const [confirm, setConfirm] = useState(false);

  console.log('selectCustomer', customer);

  const onClose = () => {
    if (confirm) {
      setConfirm(false);
      return;
    }
    setShow(false);
  };

  const showSuccessToast = () => {
    dispatch({
      type: 'navBars/updateState',
      payload: {
        saveDiscardToastShowing: {
          value: true,
          type: ToastType.updatedSuccessfully,
          delayTime: defaultDelayTime,
        },
      },
    });
  };

  const updateAction = () => {
    dispatch(
      createAction('singleCoupon/grantSingleCoupon')({
        couponPK: coupon?.pk,
        customerPK: selectCustomer?.value?.pk,
        afterAction: () => {
          setConfirm(false);
          setShow(false);
          showSuccessToast();
          history.push(location);
        },
      }),
    );
  };

  const primaryButtonAction = () => {
    if (!selectCustomer) {
      return;
    }
    if (!confirm) {
      setConfirm(true);
      return;
    }
    updateAction();
  };

  useEffect(() => {
    if (show) {
      setConfirm(false);
      setSelectCustomer(null);
    }
  }, [show]);

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
    >
      <Modal.Body className="base-prompt-container customer-detail-prompt coupon-select-owner">
        <Image
          src={CloseIcon}
          className="base-prompt-close-button customer-detail-prompt-close-button"
          onClick={onClose}
        />

        <label className="customer-detail-modal-title">
          {coupon?.couponType === COUPON_TYPES.TICKET
            ? 'Update ticket owner'
            : 'Update coupon owner'}
        </label>

        {!confirm ? (
          <>
            <CustomTitleLabel
              title={
                coupon?.couponType === COUPON_TYPES.TICKET
                  ? 'Select new ticket owner'
                  : 'Select new coupon owner'
              }
            />
            <CustomerFilterableDropdown
              defaultSelectedCustomer={selectCustomer}
              selectCustomer={setSelectCustomer}
            />
          </>
        ) : (
          <>
            <CustomTitleLabel
              title={
                coupon?.couponType === COUPON_TYPES.TICKET
                  ? 'Current ticket owner'
                  : 'Current coupon owner'
              }
            />
            <div className="select-customer-value">
              {`[${customer.membershipId}] ${customer.firstName} ${customer.lastName}`}
            </div>

            <CustomTitleLabel
              title={
                coupon?.couponType === COUPON_TYPES.TICKET
                  ? 'New ticket owner'
                  : 'New coupon owner'
              }
            />
            <div className="select-customer-value">{selectCustomer?.label}</div>
          </>
        )}

        <div className="base-prompt-buttons customer-detail-prompt-buttons">
          <PromptButton
            title="Cancel"
            action={onClose}
            type={BUTTON_TYPES.secondary}
          />
          <PromptButton
            title="Confirm"
            action={primaryButtonAction}
            requires={PermissionCodes.changeCoupon}
            type={BUTTON_TYPES.main}
            disabled={!selectCustomer?.value?.pk}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default connect(mapPropsToState)(CouponSelectOwnerModal);
